import { defineComponent as _defineComponent } from 'vue'
import { register } from 'vue-advanced-chat';
import store from '@/store';
import { Buffer } from 'buffer';
import useContext from '@/composition/context';

import HtmlContentMessage from './HtmlContentMessage.vue'
import { reactive, onMounted, computed, watch } from 'vue';
import { initZulip, getMessages, sendMessage, getMe } from '@/store/modules/zulipChat';

// @ts-ignore

export default /*#__PURE__*/_defineComponent({
  __name: 'Chat',
  setup(__props) {

window.Buffer = Buffer;

register();

let messagesInterval = {} as ReturnType<typeof setTimeout>;

onMounted(() => {
    login().then(() => {
        fetchMessages({ room: {}, options: { reset: true } });
    })
});

const { contextEvent, contextVisitor } = useContext();

const currentUserZulipId = computed(() => data.currentUserId);
const zulipMessages = computed(() => store.getters.messages);
const zulipChannels = computed(() => store.getters.channels);
const isSessionChannel = computed(() => store.getters.isSessionChannel);
const chatIsLogged = computed(() => store.getters.chatIsLogged);

const zulipCurrentChannel = computed(() => {
    return store.getters.currentChannel;
}
);

const data = reactive({
    currentUserId: '',
    channels: [],
    messages: [],
    groupedMessages: {},
    messagesLoaded: false,
    chat_email: "",
    hiddenChannels: ["Zulip", "sandbox", "general", "Welcome Bot", "check-in-2", "Chat"],
    currentChannel: 0,
});

watch(
    () => zulipChannels.value,
    () => {
        // store.commit('setMessagesChannels', zulipChannels.value);

        // zulipChannels.value.forEach((channel: any) => {
        //     if (!data.groupedMessages[channel.roomId]) {
        //         data.groupedMessages[channel.roomId] = [];
        //     }
        // });
    },
);

watch(
    () => contextVisitor.value,
    () => {
        if (contextVisitor.value.id) {
            data.hiddenChannels.push(contextVisitor.value.name);
            fetchMessages({ room: {}, options: { reset: true } });
        }
    },

);

watch(
    () => data.groupedMessages,
    () => {
        store.commit('setMessagesNotifications', data.groupedMessages);
    },
);

watch(
    () => data.channels,
    () => {
        if (data.channels) {
            store.commit('setMessagesChannels', data.channels);
        }
    },
);

const login = async () => {
    const currentExhibitor = store.getters.currentExhibitor;

    if (contextVisitor && !currentExhibitor && contextVisitor.value.id !== 0) {
        data.chat_email = `att${contextVisitor.value.id}@beamian.com`;
    }

    if (currentExhibitor && !contextVisitor && currentExhibitor.id !== 0) {
        data.chat_email = `exb${currentExhibitor.id}__${contextEvent.value.id}@beamian.com`;
    }

    if (data.chat_email) {
        // Login in Zulip server
        initZulip(data.chat_email).then(() => {

            // Get user information from Zulip
            getMe().then((me: any) => {
                if (me.result === "success") {
                    data.currentUserId = me.user_id.toString();
                    let auth = {
                        user_id: me.user_id,
                        email: me.email,
                        full_name: me.full_name,
                        is_admin: me.is_admin,
                    }
                    store.commit('setRocketUserLogin', auth);
                    store.commit('setChatStatus', true);
                }
            })
        }).catch((err) => {
            store.commit('setChatStatus', false);
        })
    }

    if (!data.currentUserId) {
        store.commit('setChatStatus', false);
    }
};

const verifySelectedChannel = (room: any) => {
    if (room) {
        let roomId = room.roomId;
        if (roomId) {
            // console.log("Selected chat - ", roomId);
            data.messages = data.groupedMessages[roomId];
            store.commit('setCurrentChannel', room.roomId);
        }
    } else {
        if (zulipChannels.value.length > 0) {
            let first_channel = zulipChannels.value[0].roomId;
            data.messages = data.groupedMessages[first_channel];
            store.commit('setCurrentChannel', first_channel);
        }
    }
}

const fetchMessages = ({ room, options }) => {
    if (!chatIsLogged.value) {
        login();
    }

    data.messagesLoaded = false;

    clearInterval(messagesInterval);

    if (currentUserZulipId) {
        getMessages().then((response: any) => {
            loadMessages(response.messages);
            data.messagesLoaded = true;
        });

        // Set interval to get messages
        messagesInterval = setInterval(() => {
            getMessages().then((response: any) => {
                loadMessages(response.messages);
            })
            data.messagesLoaded = true;
        }, 8000);

        if (room) {
            verifySelectedChannel(room);
        }
    }


    setTimeout(() => {
        data.messagesLoaded = true;
    })
};

// fetchMessages({ room: {}, options: { reset: true } });

const loadMessages = (rawMessages = []) => {
    let channels = <any>[];
    // Created to control messages and channels with same ID
    data.groupedMessages = {};

    rawMessages.forEach(msg => {
        let msg_type = msg.type;
        let channel_id = "";
        let channel_name = "";
        let msg_date = new Date(msg.timestamp);
        let channel_users: Array<any> = [];

        if (msg_type === 'stream') {
            channel_id = msg.stream_id.toString();
            channel_name = msg.display_recipient === "check-in-2" ? "Chat" : msg.display_recipient;
            // channel_name = msg.display_recipient;
            channel_users.push({ _id: msg.recipient_id, username: msg.display_recipient, avatar: "", target: msg.stream_id });

        } else {
            let recipients = "";
            if (msg.display_recipient.length) {
                msg.display_recipient.forEach(us => {
                    recipients += ` ${us.full_name} (${us.id}) ;`
                });
            }

            // private messages
            channel_id = "";
            msg.display_recipient.forEach(user => {
                channel_id += `_${user.id}`;
            });

            channel_name = msg.display_recipient.filter((acc) => acc.id.toString() !== data.currentUserId);
            channel_name = channel_name.length ? channel_name[0].full_name : "";

            msg.display_recipient.forEach(user => {
                let chat = { _id: user.id, username: user.full_name, avatar: "", target: user.email };
                channel_users.push(chat)
            });
        }

        if (!data.groupedMessages[channel_id]) {
            data.groupedMessages[channel_id] = [];
        }

        // Add messages only if the channel name is defined
        if (channel_name && !msg.content.includes("...sub...")) {
            // Mount message object
            let new_message = {
                _id: msg.id,
                content: parseHtmlMessage(msg.content),
                senderId: msg.sender_id.toString(),
                username: msg.sender_full_name,
                date: msg_date.toDateString(),
                timestamp: msg_date.toLocaleTimeString()
            }

            // Mount list of chats (or channels)
            let chat = {
                roomId: channel_id,
                roomName: channel_name,
                avatar: "",
                users: channel_users,
                unreadCount: 0,
                type: msg_type
            }
            if (!data.hiddenChannels.includes(chat.roomName)) {
                data.groupedMessages[channel_id].push(new_message);

                // Add channel only if it doesn't exist
                if (!channels.filter((ch) => ch.roomName === chat.roomName).length) {
                    channels.push(chat);
                }
            }
        }

    });
    data.channels = channels;
    data.messagesLoaded = true;
};

const parseHtmlMessage = (htmlString: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    // Access elements in the parsed HTML
    const paragraph = doc.querySelector("p");
    return paragraph?.textContent;
}

const submitMessage = (message: any) => {
    let type = "";
    let to = "";
    let content = message.content;
    let chat = zulipChannels.value.filter((ch) => ch.roomId === message.roomId);
    let user = null;
    if (chat && chat[0].users) {
        type = chat[0].type;
        if (chat[0].users.length > 1) {
            // Identify target user to send the message
            user = chat[0].users.filter((us) => data.chat_email !== us.target);
            to = user[0].target;
        } else {
            user = chat[0].users[0];
            to = user.target;
        }
    }
    type = type === "private" ? "private" : "stream";
    let topic = (type === "private" ? "" : "Room");
    
    sendMessage(type, to, topic, content).then((response) => {
        if (response.result === 'success') {
            reload(chat[0]);
        }
    });
};

const reload = (room_options: any) => {
    store.commit('setMessagesChannels', []);
    data.channels = []
    data.groupedMessages = [];
    data.messages = []
    fetchMessages({ room: room_options, options: { reset: false } });
}


return { __sfc: true,messagesInterval, contextEvent, contextVisitor, currentUserZulipId, zulipMessages, zulipChannels, isSessionChannel, chatIsLogged, zulipCurrentChannel, data, login, verifySelectedChannel, fetchMessages, loadMessages, parseHtmlMessage, submitMessage, reload, HtmlContentMessage }
}

})